import ms1111 from "./ms1111";
import ms61 from "./ms61";
import ms62 from "./ms62";
import ms63 from "./ms63";
import ms602 from "./ms602";
import ms67 from "./ms67";
import ms64 from "./ms64";
import ms65 from "./ms65";
import ms301 from "./ms301";
export default {ms301,
ms65,
ms64,
ms67,
ms602,
ms63,
ms62,
ms61,
ms1111,
};